/* Bootstrap  */
//import "bootstrap";
//import { Modal } from 'bootstrap'

/* Custom SCSS */
import "./index.scss";

/* SwiperJS */
import Swiper , { Navigation, Pagination, Scrollbar, Autoplay, Mousewheel } from 'swiper';
import 'swiper/css';
Swiper.use([Navigation, Autoplay, Scrollbar, Pagination, Mousewheel]);

//import 'swiper/css/navigation';
//import 'swiper/css/pagination';
//import 'swiper/css/scrollbar';
//Swiper.use([Scrollbar]);
// init Swiper:
/*
const swiper = new Swiper('.swiper', {  direction: 'vertical',
    loop: true,

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    },
    modules: [Navigation, Pagination, Scrollbar],
    ...
});
*/

/* Fancybox */
//import { Fancybox } from "@fancyapps/ui";
//import "@fancyapps/ui/dist/fancybox.css";

/* Gsap */
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

//var Isotope = require('isotope-layout');

jQuery(document).ready( function($) { 

  /* Animazione link del menu */

  const links = gsap.utils.toArray("#menu-main-menu li a");

links.forEach((link) => {
  const t = gsap
    .to(link, {
      backgroundSize: "100%"
    })
    .reverse();
  link.addEventListener("mouseenter", () => t.reversed(!t.reversed()));
  link.addEventListener("mouseleave", () => t.reversed(!t.reversed()));
});

/* TXT Slider */

    const txt_slider = gsap.utils.toArray(".swiper_slider_text");
  
    txt_slider.forEach((text) => {
     
     const TextSlideSpeed = text.dataset.sliderspeed;
     const TextSlideDelay = text.dataset.sliderdelay;
     
       const swiper_slider_text = new Swiper(text, {
         loop: true,
         freeMode: true,
         autoplay: {
           delay: TextSlideDelay,
           pauseOnMouseEnter:true,
           disableOnInteraction:false,
         },
         loopAddBlankSlides:true,
         //cssMode:true,
         slidesPerView: 1,
         speed: TextSlideSpeed,
         grabCursor: true,
         loopAdditionalSlides: 2,
       });
 
   });

   
    
    // const swiperSlider = new Swiper('.artists_wrp', {
    //     slidesPerView: 3.3,
    //     spaceBetween: 22,
    //     loop: true,
    //     autoplay: {
    //       delay: 2500,
    //       pauseOnMouseEnter: true
    //     },
    //     navigation: {
    //       nextEl: ".swiper-button-next",
    //       prevEl: ".swiper-button-prev",
    //     },
    // });

    const swiper = new Swiper(".artists_wrp", {
      slidesPerView: 1.3,
      spaceBetween: 30,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2.3,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3.3,
          spaceBetween: 40,
        },
      },
    });

    let tl_scroll_section1_out = gsap.timeline({scrollTrigger:{
        trigger:".content-wrapper",
        start:"top top",
        end:"100",
        markers: {startColor: "green", endColor: "red", fontSize: "12px"},
        scrub:1
      }})
    
      tl_scroll_section1_out.to("#logo_desktop", {
        height:'3rem',
        ease:"back",
        duration:1,
        
      })
      tl_scroll_section1_out.to(".navbar-toggler", {
        fontSize:'0.8rem',
        color:'#ffffff',
        backgroundColor:'#000000',
        ease:"back",
        duration:1,
      },'<')
      tl_scroll_section1_out.to(".navbar-toggler .icon", {
        height:28,
        width:28,
        ease:"back",
        duration:1,
      },'<')
      tl_scroll_section1_out.to(".icon_button_audioguide", {
        scale:0.8,
        backgroundColor:'#000000',
        ease:"back",
        duration:1,
      },'<')

      tl_scroll_section1_out.to(".icon_button_audioguide svg", {
        scale:0.8,
        fill:'#ffffff',
        ease:"back",
        duration:1,
      },'<')

      tl_scroll_section1_out.to(".icon_button_3dview", {
        scale:0.8,
        backgroundColor:'#000000',
        ease:"back",
        duration:1,
      },'<')

      tl_scroll_section1_out.to(".icon_button_3dview svg", {
        scale:0.8,
        fill:'#ffffff',
        ease:"back",
        duration:1,
      },'<')

      tl_scroll_section1_out.to(".navbar-toggler .toggler-icon", {
        backgroundColor:'#ffffff',
        ease:"back",
        duration:1,
      },'<');


      let menuOpen = 0;

       let tl_icon_menu = gsap.timeline();

      $('body').on('mouseenter', '.navbar-toggler', function() {
       
        tl_icon_menu.to(".navbar-toggler", {
             backgroundColor:'#000',
            ease:"back",
            duration:.5,
        });
        tl_icon_menu.to(".navbar-toggler .toggler-icon", {
             backgroundColor:'#fff',
            ease:"back",
            duration:.3,
        },'<');
        tl_icon_menu.to(".navbar-toggler.dark_txt", {
            color:'#fff',
            ease:"back",
            duration:.5,
        },'<');
      });


      $('body').on('mouseleave', '.navbar-toggler', function() {
        if( menuOpen === 1 ){

        }else{
          tl_icon_menu.to(".navbar-toggler .toggler-icon", {
             backgroundColor:'#000',
              ease:"back",
              duration:.5,
          });
          tl_icon_menu.to(".navbar-toggler.dark_txt", {
              color:'#000',
              ease:"back",
              duration:.3,
          },'<');
          tl_icon_menu.to(".navbar-toggler", {
              backgroundColor:'#fff',
              ease:"back",
              duration:.5,
          },'<');
        }
        
      });
   
      
      $('body').on('click', '.navbar-toggler', function() {
        let tl_scroll_menu = gsap.timeline();
        if( menuOpen === 0 ){
          tl_scroll_menu.to(".active_background", {
            width:'100vw',
            ease:"back",
            duration:.5,
          },'<');
          tl_scroll_menu.to(".header", {
            height:'100vh',
            ease:"back",
            duration:.5,
          });
          tl_scroll_menu.to("#menu-main-menu li", {
            duration: 1,
            opacity: 1,
            height: "auto",
            delay: 0.5,
            stagger: 0.1,
            ease: "sine.out"
          },'<');

          tl_scroll_menu.to(".contatti_wrp", {
            duration: 1,
            opacity: 1,
            height: "auto",
            delay: 0.5,
            ease: "sine.out"
          },'<');

          
          menuOpen=1;
          console.log(menuOpen);
        }else{

          tl_scroll_menu.to(".contatti_wrp", {
            duration: 1,
            opacity: 0,
            height: 0,
            ease: "sine.out"
          });

          tl_scroll_menu.to("#menu-main-menu li", {
            duration: 0.5,
            opacity: 0,
            height: 0,
            delay: 0.3,
            stagger: 0.1,
            ease: "sine.out"
          },'<');

          tl_scroll_menu.to(".header", {
            height:"auto",
            ease:"back",
            duration:1,
          });
          tl_scroll_menu.to(".active_background", {
            width:'0vw',
            ease:"back",
            duration:1,
          });
          menuOpen=0;
          console.log(menuOpen);
        }
        
    });


    $('body').on('click', '.menu-item .material-symbols-outlined', function() {
        $(this).next('.dropdown-menu').toggleClass('d-none');
    });

    if($(window).width()>990) {

        $('body').on('mouseenter', '.dropdown', function(){ 
            $(this).find('.dropdown-menu').removeClass('d-none');
        });
        $('body').on('mouseleave', '.dropdown', function(){ 
            $(this).find('.dropdown-menu').addClass('d-none');
        });

    }



    $('a.scroll-link, .scroll-link>a').click(function(e) {
        e.preventDefault();
        var link = $(this).attr('href');
        $('html, body').animate({ scrollTop: $('#'+link).offset().top-200}, 800);
    });

    if ($("body").hasClass("single-artisti")) {

      var items = gsap.utils.toArray(".block-sticky__content");
      var images = gsap.utils.toArray(".block-sticky__image");
      items.forEach(function (item, i) {
        gsap.from(item, {
          scrollTrigger: {
            trigger: item,
            start: "top bottom",
            end: "bottom top",
            scrub: true
          },
          opacity: 0,
          duration: 1,
          repeat: 1,
          yoyo: true,
          repeatDelay: 2,
          ease: "none"
        });

        var image = images[i];
        gsap.from(image, {
          opacity: 0,
          ease: "none",
          scrollTrigger: {
            trigger: item,
            start: "top bottom",
            end: "bottom bottom",
            toggleActions: "play reverse play reverse",
            scrub: true
          }
        });
      });

    }

    /******************* */
    /** Archvio Artisti  */
    /******************* */

   if ($('body').hasClass('post-type-archive-artisti')) {
  if ($(window).width() > 1024) {

    const elementsWorks = document.querySelectorAll(".item-work");
    const galleryWork   = document.querySelector("#gallery-work");
    const workImages    = document.querySelectorAll("#work-images .work-image");

    gsap.set(galleryWork, { autoAlpha: 0 });

    elementsWorks.forEach((element, index) => {
      element.addEventListener("mouseenter", function () {
        const imageHeight = workImages[index]?.offsetHeight ?? 280;

        gsap.to("#work-images", {
          y: -(imageHeight * index),  // usa y invece di marginTop → più performante
          duration: 0.4,
          ease: "power2.out",
        });
      });
    });

    // gallery box segue il cursore — position:fixed quindi NO scrollY
    window.addEventListener("mousemove", function (e) {
      gsap.to(galleryWork, {
        top:      e.clientY,
        left:     e.clientX,
        xPercent: -20,
        yPercent: -45,
        duration: 0.2,
        ease:     "power1",
      });
    });

    document.querySelector(".items-works").addEventListener("mouseenter", function () {
      gsap.to(galleryWork, { autoAlpha: 1, duration: 0.2, ease: "power1" });
    });

    document.querySelector(".items-works").addEventListener("mouseleave", function () {
      gsap.to(galleryWork, { autoAlpha: 0, duration: 0.2, ease: "power1" });
    });

  }
}
  
/******************* */
/** Single Artista — Audio Player */
/******************* */

if ($('body').hasClass('single-artisti')) {

  function formatTime(seconds) {
    if (isNaN(seconds) || seconds === Infinity) return '--:--';
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  }

  const section = document.querySelector('#artist_audiplayer');

  if (section) { // ← if invece di return

    const audio     = section.querySelector('audio');
    const playerBtn = section.querySelector('.player-button');
    const timeline  = section.querySelector('.timeline');
    const timerPar  = section.querySelector('.timer_par');
    const timerTot  = section.querySelector('.timer_tot');
    const bars      = section.querySelectorAll('.single_bar');

    const playIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="15.298" height="16.906" viewBox="0 0 15.298 16.906"><defs><style>.cls-1{fill:#ccc;}</style></defs><g transform="translate(-381.5 -232.547)"><path class="cls-1" d="M0,1.761V14.052a1.772,1.772,0,0,0,2.672,1.6l10.69-6.235a1.693,1.693,0,0,0,0-3.028L2.672.158A1.9,1.9,0,0,0,0,1.761Z" transform="translate(382 233.047)"/><path class="cls-1" d="M1.9-.5a2.437,2.437,0,0,1,.965.2L2.9-.289l10.717,6.25a2.192,2.192,0,0,1,0,3.894L2.924,16.087a2.322,2.322,0,0,1-1.165.319A2.284,2.284,0,0,1-.5,14.052V1.761A2.171,2.171,0,0,1,.243.136,2.513,2.513,0,0,1,1.9-.5ZM2.449.607A1.44,1.44,0,0,0,1.9.5,1.5,1.5,0,0,0,.912.88,1.184,1.184,0,0,0,.5,1.761V14.052a1.3,1.3,0,0,0,1.26,1.354,1.33,1.33,0,0,0,.665-.185L13.11,8.989a1.2,1.2,0,0,0,0-2.162Z" transform="translate(382 233.047)"/></g></svg>`;

    const pauseIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="14.4" height="16.002" viewBox="0 0 14.4 16.002"><defs><style>.cls-1{fill:#ccc;}</style></defs><path class="cls-1" d="M-939.4-17056a1,1,0,0,1-1-1v-14a1,1,0,0,1,1-1h2.8a1,1,0,0,1,1,1v14a1,1,0,0,1-1,1Zm-9.6,0a1,1,0,0,1-1-1v-14a1,1,0,0,1,1-1h2.8a1,1,0,0,1,1,1v14a1,1,0,0,1-1,1Z" transform="translate(950 17072)"/></svg>`;

    audio.addEventListener('loadedmetadata', () => {
      timerTot.textContent = formatTime(audio.duration);
    });

    audio.addEventListener('timeupdate', () => {
      const pct = (audio.currentTime / audio.duration) * 100;
      timeline.value = pct;
      timeline.style.backgroundSize = `${pct}% 100%`;
      timerPar.textContent = formatTime(audio.currentTime);
    });

    audio.addEventListener('ended', () => {
      playerBtn.innerHTML = playIcon;
      section.querySelector('.audio-player').classList.remove('audio-player_active');
      bars.forEach(b => b.classList.add('paused'));
      timeline.value = 0;
      timeline.style.backgroundSize = '0% 100%';
      timerPar.textContent = '0:00';
    });

    timeline.addEventListener('input', () => {
      audio.currentTime = (timeline.value * audio.duration) / 100;
    });

    function toggleAudio() {
      if (audio.paused) {
        audio.play();
        playerBtn.innerHTML = pauseIcon;
        section.querySelector('.audio-player').classList.add('audio-player_active');
        bars.forEach(b => b.classList.remove('paused'));
      } else {
        audio.pause();
        playerBtn.innerHTML = playIcon;
        section.querySelector('.audio-player').classList.remove('audio-player_active');
        bars.forEach(b => b.classList.add('paused'));
      }
    }

    playerBtn.addEventListener('click', toggleAudio);

    const footer = document.querySelector('#footer');
    if (footer) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          gsap.to(section, {
            autoAlpha: entry.isIntersecting ? 0 : 1,
            duration: 0.4,
            ease: 'power2.out'
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(footer);
    }

  } // ← chiude if (section)

} // ← chiude if single-artisti

/******************* */
/** Block Audio Artists — player multipli inline */
/******************* */

document.querySelectorAll('[data-player]').forEach((playerEl) => {

  const audio     = playerEl.querySelector('audio');
  const playerBtn = playerEl.querySelector('.player-button');
  const timeline  = playerEl.querySelector('.timeline');
  const timerPar  = playerEl.querySelector('.timer_par');
  const timerTot  = playerEl.querySelector('.timer_tot');
  const durationEl = playerEl.querySelector('.player-track-duration');
  const bars      = playerEl.querySelectorAll('.single_bar');
  const audioPlayer = playerEl.querySelector('.audio-player');

  function formatTime(seconds) {
    if (isNaN(seconds) || seconds === Infinity) return '--:--';
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  }

  const playIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="15.298" height="16.906" viewBox="0 0 15.298 16.906"><defs><style>.cls-1{fill:#000;}</style></defs><g transform="translate(-381.5 -232.547)"><path class="cls-1" d="M0,1.761V14.052a1.772,1.772,0,0,0,2.672,1.6l10.69-6.235a1.693,1.693,0,0,0,0-3.028L2.672.158A1.9,1.9,0,0,0,0,1.761Z" transform="translate(382 233.047)"/><path class="cls-1" d="M1.9-.5a2.437,2.437,0,0,1,.965.2L2.9-.289l10.717,6.25a2.192,2.192,0,0,1,0,3.894L2.924,16.087a2.322,2.322,0,0,1-1.165.319A2.284,2.284,0,0,1-.5,14.052V1.761A2.171,2.171,0,0,1,.243.136,2.513,2.513,0,0,1,1.9-.5ZM2.449.607A1.44,1.44,0,0,0,1.9.5,1.5,1.5,0,0,0,.912.88,1.184,1.184,0,0,0,.5,1.761V14.052a1.3,1.3,0,0,0,1.26,1.354,1.33,1.33,0,0,0,.665-.185L13.11,8.989a1.2,1.2,0,0,0,0-2.162Z" transform="translate(382 233.047)"/></g></svg>`;

  const pauseIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="14.4" height="16.002" viewBox="0 0 14.4 16.002"><defs><style>.cls-1{fill:#000;}</style></defs><path class="cls-1" d="M-939.4-17056a1,1,0,0,1-1-1v-14a1,1,0,0,1,1-1h2.8a1,1,0,0,1,1,1v14a1,1,0,0,1-1,1Zm-9.6,0a1,1,0,0,1-1-1v-14a1,1,0,0,1,1-1h2.8a1,1,0,0,1,1,1v14a1,1,0,0,1-1,1Z" transform="translate(950 17072)"/></svg>`;

  // Durata totale
  audio.addEventListener('loadedmetadata', () => {
    const formatted = formatTime(audio.duration);
    timerTot.textContent = formatted;
    if (durationEl) durationEl.textContent = formatted;
  });

  // Aggiorna progress
  audio.addEventListener('timeupdate', () => {
    const pct = (audio.currentTime / audio.duration) * 100;
    timeline.value = pct;
    timeline.style.backgroundSize = `${pct}% 100%`;
    timerPar.textContent = formatTime(audio.currentTime);
  });

  // Fine traccia
  audio.addEventListener('ended', () => {
    playerBtn.innerHTML = playIcon;
    audioPlayer.classList.remove('audio-player_active');
    bars.forEach(b => b.classList.add('paused'));
    timeline.value = 0;
    timeline.style.backgroundSize = '0% 100%';
    timerPar.textContent = '0:00';
  });

  // Seek
  timeline.addEventListener('input', () => {
    audio.currentTime = (timeline.value * audio.duration) / 100;
  });

  // Play / Pausa — ferma gli altri player attivi
  function toggleAudio() {
    const isPlaying = !audio.paused;

    // Ferma tutti gli altri player in pagina
    document.querySelectorAll('[data-player] audio').forEach(a => {
      if (a !== audio) {
        a.pause();
        const p = a.closest('[data-player]');
        p.querySelector('.player-button').innerHTML = playIcon;
        p.querySelector('.audio-player').classList.remove('audio-player_active');
        p.querySelectorAll('.single_bar').forEach(b => b.classList.add('paused'));
      }
    });

    if (isPlaying) {
      audio.pause();
      playerBtn.innerHTML = playIcon;
      audioPlayer.classList.remove('audio-player_active');
      bars.forEach(b => b.classList.add('paused'));
    } else {
      audio.play();
      playerBtn.innerHTML = pauseIcon;
      audioPlayer.classList.add('audio-player_active');
      bars.forEach(b => b.classList.remove('paused'));
    }
  }

  playerBtn.addEventListener('click', toggleAudio);

});

if($('.scrollToTopBtn').length) {
    var scrollToTopBtn = document.querySelector(".scrollToTopBtn");
    var rootElement = document.documentElement;
    function handleScroll() {
      var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight;
      if (rootElement.scrollTop / scrollTotal > 0.7) {
        scrollToTopBtn.classList.add("showBtn");
      } else {
        scrollToTopBtn.classList.remove("showBtn");
      }
    }
    function scrollToTop() {
      rootElement.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
    scrollToTopBtn.addEventListener("click", scrollToTop);
    document.addEventListener("scroll", handleScroll);
}


/* BLocco Parallasse */

//gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".js-parallax").forEach((section) => {

  const image = section.querySelector(".pf-parallax-banner__image");

  gsap.to(image, {
    yPercent: 20, // intensità parallax
    ease: "none",
    scrollTrigger: {
      trigger: section,
      start: "top bottom",
      end: "bottom top",
      scrub: 1.2, // più alto = più smooth
    }
  });

});


});